import React from "react";

/*
 * Policy documents are hosted by Termly and embedded in an iframe. The height has to be set explicitly to fit the
 * document because the iframe cannot report its content height across origins.
 */
export default function PolicyEmbed({title, src, height}) {

  return (
      <React.Fragment>
        <div className="lo-page-header">
          <h1>{title}</h1>
        </div>

        <div className="lo-embed">
          <iframe title={title} src={src} height={height} />
        </div>
      </React.Fragment>
  )

}
